import AxiosInstance from "../../../shared/utils/axios";
import {
  type CpNormalizedApplicationAssignment,
  type CpSavedTrialPlot,
} from "../components/CPBiological/normalizeCpAssignments";

export interface BiologicalAutoAssignmentResponse {
  trial_plots?: CpSavedTrialPlot[];
  plot_property_assignments?: {
    biological_treatment_assignments?: CpNormalizedApplicationAssignment[];
  };
}

export const fetchBiologicalAutoAssignments = async (
  trialId: string,
  signal?: AbortSignal
): Promise<BiologicalAutoAssignmentResponse> => {
  if (!trialId.trim()) {
    throw new Error("A saved trial is required for automatic assignment.");
  }

  const { data } = await AxiosInstance.get<BiologicalAutoAssignmentResponse>(
    `/trial/${encodeURIComponent(trialId)}/auto-assign-plot-properties`,
    { params: { trial_type: "biological" }, signal }
  );

  if (
    !Array.isArray(data?.trial_plots) &&
    !Array.isArray(
      data?.plot_property_assignments?.biological_treatment_assignments
    )
  ) {
    throw new Error(
      "The automatic assignment API returned invalid biological data."
    );
  }

  return data;
};
